import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    width: '30%',
    className: 'bold',
    render: function (data, type, row, meta) {
      return renderToString(
        <a href={`/admin/users/${row.DT_RowId}`}>{data}</a>
      )
    },
  },
  { data: 'email', width: '33%', render: (data) => renderToString(<span>{data}</span>) },
  { data: 'membership_number', width: '15%', render: (data) => renderToString(<span>{data}</span>) },
  {
    data: 'roles',
    width: '27%',
    orderable: false,
    render: (data, type, row, meta) => {
      if (row.organisations !== '') {
        return renderToString(
          <>
            <span>{row.roles}</span>
          </>
        )
      } else {
        return renderToString(<span>{row.roles}</span>)
      }
    },
  },
  {
    data: 'id',
    width: '10%',
    className: 'center',
    render: (data, type, row) => {
      if (row.rejected === 'false') {
        return renderToString(
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <button className="button secondary small approve-user-button" data-user-id={data}>Approve</button>
            <button className="button red small reject-user-button" data-user-id={data}>Reject</button>
          </div>
        )
      }
      return ''
    }
  },
  {
    data: 'rejected',
    visible: false,
  }
]

const headers = [
  'Name',
  'Email',
  'Membership Number',
  'Roles',
  '',
]

const filters = []

const sorters = []

const order = [[1, "asc"]]

export { columns, headers, filters, sorters, order }
